import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, CardContent, Grid, Link, Paper, Typography } from '@availity/element';

import { AvailityHeaderLogo, Footer } from '@/components';
import { TwoFAIcon00 } from '@/static';

const faqLink =
  'https://essentials.availity.com/availity/help-open/source/portal_providers/account_administration/2-step/_topics/c_faqs_for_2step_authentication.html';

function TwoFAStart({ ...props }) {
  const { stepToRender, setCurrentStep } = props;

  const handleNavigation = () => {
    // pass in same step to go to the next step;
    setCurrentStep(stepToRender);
  };

  return (
    <Grid
      id="2fa-start-page-grid-container"
      container
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      spacing={0}
      sx={{ minHeight: '100vh', justifyContent: 'center' }}
    >
      <Grid
        id="2fa-start-page-content-grid"
        container
        display="flex"
        flexDirection="column"
        alignItems="center"
        flexGrow={1}
        mt="auto"
      >
        <AvailityHeaderLogo />
        <Grid direction="column" alignItems="center" justifyContent="center">
          <Paper
            variant="elevation"
            elevation={6}
            sx={{ width: { xs: '350px', sm: '500px', md: '750px', lg: '1000px' } }}
          >
            <CardContent>
              <Grid display="flex" flexDirection="row" flexWrap="wrap">
                <Grid size={{ sm: 12, md: 4 }} sx={{ marginBottom: { xs: 2, md: 0 }, paddingRight: 2 }}>
                  <Box textAlign="center" mb={2}>
                    <img
                      src={TwoFAIcon00}
                      alt="2FA Icon"
                      style={{
                        maxWidth: '45%',
                      }}
                    />
                  </Box>
                  <Typography variant="h5" component="h3" mb={2}>
                    We take HIPAA seriously.
                  </Typography>
                  <Typography variant="subtitle1">
                    We are continually enhancing the service and security we provide our customers and their patients.
                  </Typography>
                  <Box mt={3}>
                    <Link
                      href={faqLink}
                      target="_blank"
                      loadApp={false}
                      iconPosition="end"
                      rel="noopener noreferrer"
                      aria-label="Get answers to common questions (opens PDF in a new window)"
                    >
                      2-Step Authentication FAQs
                    </Link>
                  </Box>
                </Grid>
                <Grid
                  display="flex"
                  flexDirection="column"
                  size={{ md: 8 }}
                  sx={{ borderLeft: { sm: 0, md: 1 }, borderColor: { md: '#D7DAE0' } }}
                >
                  <Box pl={2}>
                    <Typography variant="h1" mb={1}>
                      Protect Your Account
                    </Typography>
                    <Typography variant="h4" component="h2" mb={2}>
                      with 2-Step Authentication
                    </Typography>
                  </Box>
                  <Box pl={2}>
                    <Typography variant="h5" component="h3" my={2}>
                      Why am I being asked to do this?
                    </Typography>
                    <Typography variant="subtitle1">
                      Our priority is to protect your patient&apos;s protected health information (PHI). 2-step
                      authentication provides another level of security to make sure the person logging in is actually
                      you.
                    </Typography>
                  </Box>
                  <Box marginTop="auto" textAlign="right">
                    <Button color="primary" onClick={handleNavigation}>
                      Continue
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Paper>
        </Grid>
      </Grid>
      <Footer />
    </Grid>
  );
}

TwoFAStart.propTypes = {
  stepToRender: PropTypes.object.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
};

export default TwoFAStart;
